import React from "react";

import "../lib/index.css";
import { DiscountBageType } from "../lib/types/bage-type";


export function DiscountBage({children, bgColor, bageRightPos, bageTopPos, bageRotate} : DiscountBageType) {
    return (
        <div className="discount-bage" style={{backgroundColor: `${bgColor}`, top: `${bageTopPos}px`, right: `${bageRightPos}px`, transform: `${bageRotate}`}}>
            {children}
        </div>
    )
}